exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close-btn {\n  position: absolute;\n  top: 0;\n  right: 10px;\n  z-index: 100; }\n\nh5 {\n  color: #000;\n  font-size: 20px;\n  margin-top: -5px; }\n\n.errors {\n  font-family: 'Roboto', sans-serif;\n  color: #E55049;\n  font-size: 13px; }\n\n.button-selector {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  height: 50px;\n  margin-top: 15px;\n  margin-bottom: 15px; }\n\n.button-selector-Item {\n  width: 50%;\n  text-align: center;\n  line-height: 50px;\n  height: 100%; }\n  .button-selector-Item span {\n    font-size: 16px; }\n\n.left-selector {\n  border-top-left-radius: 10px;\n  border-bottom-left-radius: 10px; }\n\n.right-selector {\n  border-top-right-radius: 10px;\n  border-bottom-right-radius: 10px; }\n\n.selected {\n  background-color: #5f9bff;\n  color: white; }\n\n.unselected {\n  background-color: #d4d4d4;\n  color: #484848; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/precios-seccion/new-precio/entrega-dialog.component.scss
// module id = ../../../../../src/app/components/precios-seccion/new-precio/entrega-dialog.component.scss
// module chunks = 0